import { p as progressIndicatorStyles } from './progressIndicator-72e93a77.js';

const circularProgressIndicatorStyles = {
  ...progressIndicatorStyles,
  miniSize: '100px',
  smallSize: '125px',
  buttLineCap: 'butt',
  roundLineCap: 'round',
  default: {
    size: 'mini',
    strokeLineCap: 'round',
    marginTop: '-10px',
    strokeWidth: 9
  }
};
var circularProgressIndicatorStyles$1 = circularProgressIndicatorStyles;

export { circularProgressIndicatorStyles$1 as c };
//# sourceMappingURL=circularProgressIndicator-45e295f2.js.map
